// extracted by mini-css-extract-plugin
module.exports = {"themeRoot":"TextComponent_themeRoot__Ysng4","gwMediaSidebarTextContainer":"TextComponent_gwMediaSidebarTextContainer__287FW"};